:host {
  @include reset-host;
  height: 100%;
}

:host .pack-card {
  --paragraph-color: #{$white};
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: rem(30) 16px;

  color: $white;

  border-radius: map-get($spacing-sizes, 2);

  @include mq('max', 'md') {
    padding: 16px;
  }

  @each $color-key, $color-value in $theme-colors {
    &.is-#{$color-key} {
      background: map-get($color-value, default);
    }
  }
}

:host .product-name {
  max-width: rem(160);
  margin: 0;
  margin-bottom: rem(24);

  font-weight: $fw-bold;
  font-size: rem(32);
  line-height: 1.1;

  @include mq('max', 'md') {
    max-width: unset;
    margin-bottom: rem(4);

    font-size: rem(28);
  }
}

:host .assurance-type {
  flex: 1;
  margin-bottom: map-get($spacing-sizes, 3);

  font-weight: $fw-bold;
  font-size: $fs-2xl;
  line-height: 1.2;
  word-break: break-word;

  @include mq('max', 'md') {
    margin-bottom: map-get($spacing-sizes, 2);

    font-size: $fs-lg;
  }
}

:host .bottom-text {
  --paragraph-line-height: 1.2;
  margin-top: rem(12);

  text-align: center;

  opacity: 0.6;
}
